// Общие функции даты для BaseInput.
// Держим здесь парсинг и форматирование, чтобы popup DatePicker и ручной ввод
// не расходились в представлении одного и того же значения.

export function padDatePart(value) {
  return String(value).padStart(2, "0");
}

// Парсит оба формата, с которыми реально работает BaseInput:
// ISO-like значение модели и русский формат, который видит пользователь в маске
export function parseDateInputString(value) {
  if (!value) return null;

  let match = String(value).match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/
  );
  if (match) {
    return new Date(
      +match[1],
      +match[2] - 1,
      +match[3],
      +(match[4] || 0),
      +(match[5] || 0)
    );
  }

  match = String(value).match(
    /^(\d{2})[./](\d{2})[./](\d{4})(?:[, ]+(\d{2}):(\d{2}))?/
  );
  if (!match) return null;

  return new Date(
    +match[3],
    +match[2] - 1,
    +match[1],
    +(match[4] || 0),
    +(match[5] || 0)
  );
}

// Собирает значение, которое BaseInput эмитит наружу через v-model
// Для date нужен YYYY-MM-DD, для datetime-local нужен YYYY-MM-DDTHH:mm
export function buildDateInputEmitString(date, isDateTimeType) {
  if (isDateTimeType) {
    return `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(
      date.getDate()
    )}T${padDatePart(date.getHours())}:${padDatePart(date.getMinutes())}`;
  }

  return `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(
    date.getDate()
  )}`;
}

// Собирает видимое значение IMask
// Оно должно совпадать с тем, что пользователь видит в кастомном input DatePicker
export function formatDateInputMaskValue(date, isDateTimeType) {
  if (isDateTimeType) {
    return `${padDatePart(date.getDate())}.${padDatePart(
      date.getMonth() + 1
    )}.${date.getFullYear()}, ${padDatePart(date.getHours())}:${padDatePart(
      date.getMinutes()
    )}`;
  }

  return `${padDatePart(date.getDate())}.${padDatePart(
    date.getMonth() + 1
  )}.${date.getFullYear()}`;
}

// Готовит сразу два синхронных значения после выбора в popup DatePicker
// emitted уходит во внешний v-model, maskValue сразу пишется в IMask
// Это защищает от отката времени на первом blur/closed календаря
export function pickerDateUpdatePayload(value, isDateTimeType) {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  return {
    date,
    emitted: buildDateInputEmitString(date, isDateTimeType),
    maskValue: formatDateInputMaskValue(date, isDateTimeType),
  };
}

// Date-only можно применять сразу после выбора дня
// Datetime должен дождаться выбора времени, иначе DatePicker закрывает popup
// после клика по дате и пользователь не успевает заполнить часы и минуты
export function dateInputAutoApply(isDateTimeType) {
  return !isDateTimeType;
}

// Решает, можно ли коммитить внутреннее изменение DatePicker.
// Для datetime-local первое изменение после клика по дате пропускаем,
// потому что это ещё не законченное значение даты-времени.
// Изменение времени или явная кнопка "Выбрать" проходят отдельным событием.
export function shouldCommitDatePickerInternalUpdate(
  isDateTimeType,
  dateSelectionPending
) {
  return isDateTimeType && !dateSelectionPending;
}
